const funcionalArea = {
    FLETES: 'FLETES',
}

export default funcionalArea;